import SecondaryTitle from './SecondaryTitle';

export default SecondaryTitle;
